module.exports = __webpack_public_path__ + "img/cast_ic_challenges.f46a846f.svg";